import React from 'react'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PublicPageSF from '../../templates/PublicPageSF'
import PasswordResetStep1SF from '../../components/public/PasswordResetStep1SF'

const PasswordHelpStep1PageUI = ({context, messageList}) =>
  <PublicPageSF context={context} className='pg_passwd_stp1' backLink='/'
      messageList={messageList} headerMessageKey='c_reset_password'>
    <PageTitleUI context={context} goBack={true} backLink='/' messageList={messageList}
      titleMessageKey='c_reset_password' />

    <PasswordResetStep1SF context={context} messageList={messageList} />

  </PublicPageSF>

export default PasswordHelpStep1PageUI
